import { useSearchParams } from 'react-router-dom';

export const useInvestigationMetricUrlUpdate = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateMetricInUrl = (stableMetricId: string, isSelected: boolean) => {
    const newParams = new URLSearchParams(searchParams);
    const currentMetricIds =
      newParams
        .get('metricId')
        ?.split(',')
        .map(id => id.trim())
        .filter(Boolean) || [];

    if (isSelected) {
      // Add metric if not already present
      if (!currentMetricIds.includes(stableMetricId)) {
        currentMetricIds.push(stableMetricId);
        newParams.set('metricId', currentMetricIds.join(','));
      }
    } else {
      // Remove metric
      const updatedMetricIds = currentMetricIds.filter(id => id !== stableMetricId);
      if (updatedMetricIds.length > 0) {
        newParams.set('metricId', updatedMetricIds.join(','));
      } else {
        newParams.delete('metricId');
      }
    }

    setSearchParams(newParams, { replace: true });
  };

  return { updateMetricInUrl };
};
